






















































































































































import { Component, Watch, Prop } from 'vue-property-decorator';
import { DepositAccountModule } from '@/store/Accounts/DepositAccountModule';
import { LendingAccountModule } from '@/store/Accounts/LendingAccountModule';
import { VuetifyConfirmObject } from 'vuetify-confirm';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import CardCreate from '@/components/Accounts/Shared/Cards/CardCreate.vue';
import CardEdit from '@/components/Accounts/Shared/Cards/CardEdit.vue';
import CardExample from '@/components/Accounts/Shared/Cards/CardExample.vue';
import Card from '@/models/Accounts/Shared/Cards/Card';
import DepositAccount from '@/models/Accounts/DepositAccounts/DepositAccount';
import ProductType from "@/models/Products/ProductType";
import PermissionUtils from '@/lib/permissionUtils';
import PermissionType from '@/models/Settings/Roles/PermissionType';
import FeatureToggleCode from "@/models/Settings/Institutions/FeatureToggleCode";
import AppConsts from '@/lib/appConstants';

@Component({ name: 'Cards', components: { CardCreate, CardEdit, CardExample } })
export default class extends SaascadaVue {

    @Prop({required: true})
    account: DepositAccount;

    @Prop({required: true})
    productType: ProductType;

    PermissionUtils = PermissionUtils;
    PermissionType = PermissionType;
    FeatureToggleCode = FeatureToggleCode;
    AppConsts = AppConsts;

    headers = [
        { text: this.$t('pageText.depositAccounts.fields.name'), width: "40%" },
        { text: this.$t('pageText.depositAccounts.fields.enabled'), width: "30%" },
        { text: this.$t('pageText.depositAccounts.fields.cardProcessor'), width: "30%" }
    ];
    cardsPage = 1;

    async created() {
        // Check for page number in URL parameters
        const page = this.$route.query.page;
        if (page) {
            this.cardsPage = +page;
        }
    }

    async beforeMount() {
        await this.getCards();
    }

    async getCards() {
        if (this.productType === ProductType.Deposit) {
            await DepositAccountModule.getCards(this.cardsPage);
        }
        else {
            await LendingAccountModule.getCards(this.cardsPage);
        }
    }

    @Watch('cardsPage')
    async onCardsPageChanged() {
        // Update route with tab and page number (if it has changed)
        if (this.cardsPage !== +this.$route.query.page) {
            this.$router.push({ name: this.$route.name, params: { id: this.$route.params.id }, query: { tab: `${this.$route.query.tab}`, page: `${this.cardsPage}` } });
        }
        // Get new cards
        await this.getCards();
    }

    get checkPermissions() {
        if (this.productType === ProductType.Deposit) {
            return PermissionUtils.hasPermission(PermissionType.DepositAccountsManage) && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ManageCards);
        }
        else {
            return PermissionUtils.hasPermission(PermissionType.LendingAccountsManage) && PermissionUtils.isFeatureToggleEnabled(FeatureToggleCode.ManageCards);
        }
    }

    get cards() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.cards;
        }
        else {
            return LendingAccountModule.cards;
        }
    }

    get totalCardsPages() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.totalCardsPages;
        }
        else {
            return LendingAccountModule.totalCardsPages;
        }
    }

    get pageSize() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.pageSize;
        }
        else {
            return LendingAccountModule.pageSize;
        }
    }

    get loading() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.loadingCards;
        }
        else {
            return LendingAccountModule.loadingCards;
        }
    }

    async updateCurrentCard(card: Card) {
        if (this.productType === ProductType.Deposit) {
            await DepositAccountModule.updateCurrentCard(card);
        }
        else {
            await LendingAccountModule.updateCurrentCard(card);
        }
    }

    get currentCard() {
        if (this.productType === ProductType.Deposit) {
            return DepositAccountModule.currentCard;
        }
        else {
            return LendingAccountModule.currentCard;
        }
    }

    async deleteCard() {
        const options: VuetifyConfirmObject = {
            buttonTrueText: "Delete",
            buttonFalseText: "Close",
            buttonTrueColor: "primary",
            buttonFalseColor: "primary",
        }
        const result = await this.$confirm('Are you sure you want to delete this card?', options);
        if (result) {
            if (this.productType === ProductType.Deposit) {
                await DepositAccountModule.deleteCard(this.currentCard.id);
                await DepositAccountModule.getCards(1);
            }
            else {
                await LendingAccountModule.deleteCard(this.currentCard.id);
                await LendingAccountModule.getCards(1);
            }
            this.cardsPage = 1;
        }
    }

    get allowCardsOnAccount() {
        // TODO: This always returns true right now because the card settings are not available on the API and therefore we
        // can't yet tell if cards are enabled or not on an account, so for now always show it
        return true;
    }

}
